import { Pipe, PipeTransform } from '@angular/core';
import { Item } from '../../shared/models/domain/item';
@Pipe({
  name: 'transferFilter',
})
export class TransferFilterPipe implements PipeTransform {
  transform(items: Item[], type: string): any[] {
    if (!items) return [];
    if ((!type) || (type === 'ALL_TYPE')) return items;
    return items.filter(transfer => {
      return transfer.serviceType === type;
    });
  }
}
